import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { stripLang } from "@/lib/navigation";

/**
 * Scrolls to the top on route changes, but NOT when the user only
 * switches language (same page, different language prefix) and not when
 * the URL carries an anchor.
 */
const ScrollToTop = () => {
  const location = useLocation();
  const previous = useRef(null);

  useEffect(() => {
    const current = location.pathname;
    const prev = previous.current;
    previous.current = current;

    if (location.hash) return;
    if (prev === null) {
      window.scrollTo(0, 0);
      return;
    }
    if (prev === current) return;
    // Language switch only -> keep scroll position
    if (stripLang(prev) === stripLang(current)) return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollToTop;
